import { render, staticRenderFns } from "./StepLabel.vue?vue&type=template&id=155a41ca&"
import script from "./StepLabel.vue?vue&type=script&lang=js&"
export * from "./StepLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports